import iconButton from './comps/iconButton';
import fontFamily from './comps/fontFamily/fontFamily';
import { FontPicker } from './comps/fontPicker';
import password from './comps/password/password';
import iconsDropDown from './comps/iconsDropDown';
import textBackgroundColor from './comps/textBackgroundColor';
import textLinkControl from './comps/textLinkControl';
import textStyle from './comps/textStyle/textStyle';
import textColor from './comps/textColor';
import textEffects from './comps/textEffects';
import lineHeight from './comps/lineHeight';
import richTextFrame from './comps/richTextFrame';
import textPopup from './comps/textPopup';
import themeFontsLoader from './comps/themeFontsLoader';
import saveTextStyleConfirmation from './comps/saveTextStyleConfirmation/saveTextStyleConfirmation';
import constants from './utils/constants';
import * as fontUtils from './utils/fontUtils';
import * as dataUtils from './utils/dataUtils';
import { LinksManager } from './utils/textLinkManager';
import { LinksHelper } from './utils/linksHelper';
import * as ckUtils from './utils/ckUtils';
import * as mobileUtils from './utils/mobileUtils';
import * as migrationUtils from './utils/migrationUtils';
import { getTextTooltip } from './utils/textTooltip';
import * as colorUtils from './utils/colorUtils';
import * as textLimitsUtils from './utils/textLimitsUtils';
import { withCKEditor } from './hocs/withCKEditor';
import { withTextStyleActions } from './hocs/withTextStyleActions';
import textThemesUtils from './utils/textThemes';
import * as textEditingUtils from './utils/textEditingUtils';
import * as themedActions from './utils/themedAction';
import * as nonThemedAction from './utils/nonThemedAction';
import * as actions from './actions';
import * as textAction from './utils/textAction';

export type { CKEditorInjectedProps } from './hocs/withCKEditor';
export type { LinksHelperType } from './utils/linksHelper';
export type { NonThemedAction, ThemedAction } from './utils/textAction';
export type { WithTextStyleActionsConnectProps } from './hocs/withTextStyleActions';
export type { FontTheme } from './utils/fontUtils';
export type { TextThemeStyleMap } from './utils/textThemes';

export type CkOff = typeof constants.CK_OFF;

export {
  textStyle,
  fontFamily,
  password,
  iconButton,
  iconsDropDown,
  textBackgroundColor,
  textLinkControl,
  textColor,
  textEffects,
  lineHeight,
  textPopup,
  richTextFrame,
  themeFontsLoader,
  constants,
  fontUtils,
  dataUtils,
  ckUtils,
  mobileUtils,
  getTextTooltip,
  saveTextStyleConfirmation,
  migrationUtils,
  colorUtils,
  LinksManager,
  textLimitsUtils,
  LinksHelper,
  withCKEditor,
  withTextStyleActions,
  textThemesUtils,
  textEditingUtils,
  themedActions,
  nonThemedAction,
  actions,
  textAction,
  FontPicker,
};
